import { render, staticRenderFns } from "./RiskActive.vue?vue&type=template&id=0bb678ba"
import script from "./RiskActive.vue?vue&type=script&lang=js"
export * from "./RiskActive.vue?vue&type=script&lang=js"
import style0 from "./RiskActive.vue?vue&type=style&index=0&id=0bb678ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports